export const orders = [
  {
    id: "ORD-20260905-001",
    code: "HN000007",
    customer: "Alex Jeffs",
    issuedAt: "2026-09-05",
    product: "Sports Shoes",
    quantity: 4,
    quantityLabel: "4 pairs",
    unitPrice: 235.25,
    amount: 941,
    currency: "GBP",
    recipient: "Alex Jeffs",
    address: "133 Woodlands, Grange Park, NN4 5BZ",
    trackingNumber: "MZ 5504 4380 0GB",
    carrierStatus: "Delivered",
    sellerId: "stockforyou-ltd",
    image: "/img/products/product-20.jpg",
  },
  {
    id: "ORD-20260910-001",
    code: "HN000049",
    customer: "Luis Semedo",
    issuedAt: "2026-09-10",
    product: "Casual Shoes",
    quantity: 3,
    quantityLabel: "3 pairs",
    unitPrice: 157,
    amount: 471,
    currency: "GBP",
    recipient: "Luis Semedo",
    address: "56a Exeter Road, Exmouth, EX8 1PY",
    trackingNumber: "MZ 5523 0777 5GB",
    carrierStatus: "Delivered",
    sellerId: "enzirot-limited",
    image: "/img/products/product-02.jpg",
  },
];

export const customers = [
  {
    id: "stockforyou-ltd",
    name: "STOCKFORYOU LTD",
    address: "11 GROVE STREET SOUTH HALIFAX UNITED KINGDOM HX1 4LD",
    contact: "C👋🏻",
    storeUrl: "https://www.mobraskon.xyz",
    firstVisit: "2026-08-31",
    status: "Active Customers",
  },
  {
    id: "enzirot-limited",
    name: "ENZIROT LIMITED",
    address:
      "291597 OFFICE SUITE 29A, 3/F 23 WHARF STREET, LONDON, ENGLAND SE8 3GG",
    contact: "Umar Bello",
    storeUrl: "https://www.mvandora.store",
    firstVisit: "2026-09-01",
    status: "Active Customers",
  },
];

export const formatOrderAmount = (amount) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);

export const formatAccountDate = (date) =>
  new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${date}T12:00:00`));
